import React, { useEffect, useLayoutEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  DatePicker as antdDatePick,
  Carousel,
  List,
  Form,
  Input as AntInput,
  message,
  Badge,
  Collapse,
  Select,
  Radio,
  Modal,
  Space,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  RollbackOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import "antd/dist/reset.css";
import dayjs from "dayjs";
import "./Booking.css";
import { displayMessage, getAPI, postAPI } from "../../../../utils/common";
import {
  BACKEND_BASE_URL,
  BOOKING_PAYMENT,
  BOOKING_ROOMS,
  BOOKING_STORE,
  IMAGE_BASE_URL,
  SETTING,
} from "../../../../constants/api";
import LS_SERVICE from "../../../../utils/localStorage";
import {
  ERROR_MSG_TYPE,
  SUCCESS_MESSAGE,
} from "../../../../constants/messages";
import BookingPaymentSuccessModal from "./BookingPaymentSuccessModal";
import moment from "moment";
import { useParams } from "react-router-dom";
import { calculateTotalBill, RADIUS } from "../../../../constants/constent";
import assets from "../../../../utils/ImagesPath";
import RoomPopup from "./RoomPopup";
import ServiceList from "./ServiceList";

const { RangePicker } = antdDatePick;

const CommonBookingForm = () => {
  const { theme } = LS_SERVICE.get("setting") || {};
  const { company_name } = LS_SERVICE.get("setting") || {};

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [modalVisible, setModalVisible] = useState(false);

  // Update isMobile on window resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { start_date, end_date, adult_count, child_count, room_id } =
    useParams();

  const startDate = start_date || null;
  const endDate = end_date || null;
  const adultCount = adult_count || 1;
  const childCount = child_count || 0;

  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [roomPopup, setRoomPopup] = useState(false);
  const [roomDetail, setRoomDetail] = useState(null);

  // const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  // const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [dateCopied, setDateCopied] = useState(false);
  const [cart, setCart] = useState([]);
  const [dates, setDates] = useState([
    dayjs().add(1, "days"),
    dayjs().add(2, "days"),
  ]);
  const [days, setDays] = useState(1);
  const [adults, setAdults] = useState(parseInt(adultCount));
  const [children, setChildren] = useState(parseInt(childCount));
  const [isCheckout, setIsCheckout] = useState(false);
  const [isPaySuccess, setIsPaySuccess] = useState(false);
  const [userDetails, setUserDetails] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [setting, setSetting] = useState(null);
  const [paymentMode, setPaymentMode] = useState("full"); // "full" or "partial"

  // const [totalAmount, setTotalAmount] = useState(0);
  const [gstBillSummery, setGstBillSummery] = useState(
    calculateTotalBill(cart || [], [], days, 0)
  );

  const calculateTotal = () => {
    let gstBillSummery = calculateTotalBill(cart || [], [], days, 0);
    setGstBillSummery(gstBillSummery);
    // setTotalAmount(gstBillSummery.summary.grandTotal);
  };

  useEffect(() => {
    calculateTotal();
  }, [cart, days, dates]);

  const siteData = (rooms_list = rooms) => {
    if (startDate && endDate && !dateCopied) {
      setDates([dayjs(startDate), dayjs(endDate)]);
      totalDays([dayjs(startDate), dayjs(endDate)]);
      setDateCopied(true);
    }
    if (room_id) {
      const room = rooms_list.find((e) => e.id === parseInt(room_id));
      if (room) {
        addToCart(room);
      }
    }
  };

  const getData = (adult = adults, child = children, new_dates = dates) => {
    setLoading(true);
    // clearData();
    const successFn = function (data) {
      if (data.status === true) {
        setRooms(data["data"]["rooms"]);
        setFilteredData(data["data"]["rooms"]);
        siteData(data["data"]["rooms"]);
        setLoading(false);
      } else {
        setRooms([]);
        setFilteredData([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setRooms([]);
      setFilteredData([]);
      setLoading(false);
    };
    postAPI(
      BOOKING_ROOMS,
      {
        start_date: dayjs(new_dates[0]).add(330, "minutes"),
        end_date: dayjs(new_dates[1]).add(330, "minutes"),
        adults: adult,
        children: child,
      },
      successFn,
      errorFn
    );
  };

  useLayoutEffect(() => {
    const loadData = async () => {
      if (LS_SERVICE.get("id") && LS_SERVICE.get("user_type") === "customer") {
        setUserDetails({
          email: LS_SERVICE.get("email"),
          phone: LS_SERVICE.get("phone"),
          name: LS_SERVICE.get("name"),
        });
      }
    };

    getSetting();
    loadData();
    getData();
    totalDays();
  }, []);

  const getSetting = () => {
    setLoading(true);
    const handleSettingSuccess = (data) => {
      if (data.status) {
        setSetting(data.data);
      } else {
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
      setLoading(false);
    };

    const handleSettingError = () => {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Get Setting");
    };
    getAPI(SETTING, handleSettingSuccess, handleSettingError);
  };

  const closeSuccessModel = () => {
    setIsPaySuccess(false);
    clearData();
    getData();
  };

  const clearData = () => {
    setCart([]);
    setIsCheckout(false);
    setUserDetails({
      name: "",
      email: "",
      phone: "",
    });
  };

  const totalDays = (new_dates = dates) => {
    if (!new_dates || new_dates.length < 2 || !new_dates[0] || !new_dates[1])
      return;
    let totalDays = new_dates[1].diff(new_dates[0], "day");
    if (new_dates[0].isSame(new_dates[1], "day")) {
      totalDays = 1;
    } else if (new_dates[0].isBefore(new_dates[1])) {
      // No need to reassign totalDays here as it's already correctly calculated
      // totalDays = totalDays;
    }
    setDays(totalDays);
  };

  // const handleSearch = (value) => {
  //   setSearchText(value);
  //   const filtered = rooms.filter(
  //     (room) =>
  //       room.room_name.toLowerCase().includes(value.toLowerCase()) ||
  //       room.room_no.toString().includes(value)
  //   );
  //   setFilteredData(filtered);
  // };

  const addToCart = (villa) => {
    if (cart.some((item) => item.id === villa.id)) {
      message.warning("This room is already in the cart.");
      return;
    }
    setCart([...cart, villa]);
  };

  const removeFromCart = (villaId) => {
    setCart(cart.filter((villa) => villa.id !== villaId));
  };

  const isInCart = (room) => {
    return cart.some((item) => item.id === room.id);
  };

  const handleCheckout = () => {
    if (cart.length === 0) {
      message.warning("Please add rooms to your cart before proceeding.");
      return;
    }
    setIsCheckout(true);
  };

  const handleFormSubmit = (values) => {
    if (!values.name || !values.email || !values.phone) {
      message.error("Please fill in all the details.");
      return;
    }
    if (cart.length === 0) {
      message.warning("Please add rooms to your cart before proceeding.");
      return;
    }

    const room_ids = cart.map((e) => e.id);
    const finalAmountToPay =
      paymentMode === "partial"
        ? Math.round(
            (gstBillSummery.summary.grandTotal *
              setting?.partial_payment_percentage ?? 0) / 100
          )
        : gstBillSummery.summary.grandTotal;

    const form_body = {
      bill_amount: finalAmountToPay,
      name: values.name,
      email: values.email,
      phone: values.phone,
      selected_rooms: room_ids,
      total_days: days,
      start_date: dates[0].add(330, "minutes"),
      end_date: dates[1].add(330, "minutes"),
      booking_segment: "booking-engine",
      booking_source: "website",
    };

    // return;
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        const options = {
          key: data.options.key,
          amount: data.options.amount * 100,
          currency: data.options.currency,
          name: data.options.name,
          description: data.options.description,
          image: IMAGE_BASE_URL + data.options.image,
          order_id: data.options.order_id,
          prefill: {
            name: data.options.prefill.name,
            email: data.options.prefill.email,
            contact: data.options.prefill.contact,
          },
          handler: function (response) {
            let body = {
              ...response,
              ...form_body,
            };
            const successFn = function (data) {
              setLoading(false);
              setIsPaySuccess(true);
              clearData();
              displayMessage(SUCCESS_MESSAGE, data.message);
            };
            const errorFn = function () {
              setLoading(false);
              setIsPaySuccess(false);
              displayMessage(
                ERROR_MSG_TYPE,
                "Unable to do payment verification"
              );
            };
            postAPI(BOOKING_STORE, body, successFn, errorFn);
          },
          theme: {
            color: "#" + theme,
          },
        };
        const razorpay = new window.Razorpay(options);
        razorpay.open();
      } else {
        displayMessage(ERROR_MSG_TYPE, data.message);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setLoading(false);
    };
    postAPI(BOOKING_PAYMENT, form_body, successFn, errorFn);
  };

  const onChange = (value) => {
    setDates(value);
    totalDays(value);
    getData(adults, children, value);
  };

  return (
    <>
      <div className="room-container">
        <div className="room-image-container">
          <img
            src={assets.header_bg}
            className="room-image img-fluid room-image-overlay"
            alt="room-image"
          />
          <div className="room-info">
            <h4>Book your stay with {company_name}</h4>
            <p>
              Seamless Direct Booking for the best Stay - No Extra Fees, No
              Hassle!
            </p>
          </div>
          <div className="room-details-container">
            <Row gutter={[16, 16]} justify={"space-between"}>
              {/* Check-in / Check-out */}
              <Col xs={24} sm={24} md={12}>
                <div className="room-detail">
                  <h2>
                    <strong>Check-in / Check-out</strong>
                  </h2>
                  {isMobile ? (
                    <>
                      <Button
                        style={{ width: "100%" }}
                        onClick={() => setModalVisible(true)}
                      >
                        {dates
                          ? `${dates[0].format(
                              "YYYY-MM-DD"
                            )} - ${dates[1].format("YYYY-MM-DD")}`
                          : "Select Date Range"}
                      </Button>

                      <Modal
                        title="Select Check-in / Check-out"
                        visible={modalVisible}
                        onCancel={() => setModalVisible(false)}
                        onOk={() => setModalVisible(false)}
                        okText="Confirm"
                        cancelText="Cancel"
                      >
                        <RangePicker
                          value={dates}
                          onChange={onChange}
                          disabledDate={(current) =>
                            current && current.isBefore(moment().startOf("day"))
                          }
                          style={{ width: "100%" }}
                          dropdownClassName="custom-range-picker-dropdown"
                          inputReadOnly
                        />
                      </Modal>
                    </>
                  ) : (
                    <RangePicker
                      style={{ width: "100%" }}
                      value={dates}
                      onChange={onChange}
                      disabledDate={(current) =>
                        current && current.isBefore(moment().startOf("day"))
                      }
                      dropdownClassName="custom-range-picker-dropdown"
                      onOpenChange={(open) => {
                        if (open && window.innerWidth < 768) {
                          setTimeout(() => {
                            window.scrollBy(0, 200);
                          }, 100);
                        }
                      }}
                    />
                  )}
                  {/* <RangePicker
                    style={{ width: "100%" }}
                    value={dates}
                    onChange={(value) => {
                      setDates(value);
                      totalDays(value);
                      getData(adults, children, value);
                    }}
                    disabledDate={(current) =>
                      current && current < moment().endOf("day")
                    }
                    dropdownClassName="custom-range-picker-dropdown"
                    onOpenChange={(open) => {
                      if (open && window.innerWidth < 768) {
                        setTimeout(() => {
                          window.scrollBy(0, 200);
                        }, 100); // allow time for popup render
                      }
                    }}
                  /> */}
                </div>
              </Col>

              {/* Adults */}
              <Col xs={12} sm={12} md={6}>
                <div className="room-detail">
                  <h2>
                    <strong>Adult</strong>
                  </h2>
                  <Select
                    value={adults}
                    onChange={(value) => {
                      setAdults(value);
                      getData(value, children);
                    }}
                    style={{ width: "100%" }}
                    options={[
                      { value: 1, label: "1 Adult" },
                      { value: 2, label: "2 Adults" },
                      { value: 3, label: "3 Adults" },
                      { value: 4, label: "4 Adults" },
                      { value: 5, label: "5 Adults" },
                    ]}
                  />
                </div>
              </Col>

              {/* Children */}
              <Col xs={12} sm={12} md={6}>
                <div className="room-detail">
                  <h2>
                    <strong>Children</strong>
                  </h2>
                  <Select
                    value={children}
                    onChange={(value) => {
                      setChildren(value);
                      getData(adults, value);
                    }}
                    style={{ width: "100%" }}
                    options={[
                      { value: 0, label: "0 Children" },
                      { value: 1, label: "1 Child" },
                      { value: 2, label: "2 Children" },
                      { value: 3, label: "3 Children" },
                      { value: 4, label: "4 Children" },
                    ]}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      <Row gutter={[16, 16]} justify="center">
        {/* Left Column */}
        <Col xs={24} sm={20} md={16} lg={12} xl={18}>
          {/* <Input
            placeholder="Search by Name or Room No"
            value={searchText}
            onChange={(e) => handleSearch(e.target.value)}
            style={{ width: "100%" }}
          /> */}
          {/* 
          <div
            style={{
              borderTop: "1px dashed #ccc",
              margin: "15px 0",
              width: "100%",
            }}
          /> */}
          {!isCheckout ? (
            <List
              loading={loading}
              itemLayout="vertical"
              dataSource={filteredData}
              renderItem={(room) => (
                <Card
                  style={{ marginBottom: "10px", borderRadius: RADIUS }}
                  key={room.id}
                  actions={
                    cart.some((item) => item.id === room.id) &&
                    room.similar_rooms.length
                      ? [
                          <Collapse
                            style={{
                              marginLeft: "10px",
                              marginRight: "10px",
                            }}
                            bordered={false}
                            defaultActiveKey={["1"]}
                            items={[
                              {
                                key: "1",
                                label: (
                                  <h3>
                                    <strong>Similar Room's</strong>
                                  </h3>
                                ),
                                extra: (
                                  <Badge count={room.similar_rooms.length} />
                                ),
                                children: (
                                  <Row gutter={[16, 16]}>
                                    {room.similar_rooms.map((s_child) => (
                                      <Col
                                        xs={24}
                                        sm={12}
                                        md={6}
                                        lg={6}
                                        key={s_child.id}
                                      >
                                        <Badge.Ribbon
                                          text={s_child.room_category.title.toUpperCase()}
                                        >
                                          <Card
                                            cover={
                                              <img
                                                alt={s_child.room_name}
                                                src={
                                                  IMAGE_BASE_URL +
                                                  s_child.room_images[0].image
                                                    .filePath
                                                }
                                              />
                                            }
                                            actions={[
                                              !isInCart(s_child) ? (
                                                <PlusOutlined
                                                  onClick={() =>
                                                    addToCart(s_child)
                                                  }
                                                />
                                              ) : (
                                                <DeleteOutlined
                                                  disabled={!isInCart(s_child)}
                                                  onClick={() =>
                                                    removeFromCart(s_child.id)
                                                  }
                                                />
                                              ),
                                            ]}
                                          >
                                            <Row gutter={[16, 16]}>
                                              <Col span={12}>
                                                <h3
                                                  style={{
                                                    textAlign: "start",
                                                  }}
                                                >
                                                  <strong>
                                                    {s_child.room_name}
                                                  </strong>
                                                </h3>
                                              </Col>
                                              <Col span={12}>
                                                <h4
                                                  style={{
                                                    textAlign: "end",
                                                  }}
                                                >
                                                  INR {s_child.room_amt}
                                                </h4>
                                              </Col>
                                            </Row>
                                            <ServiceList
                                              room_type={s_child.room_type}
                                              occupancy={s_child.occupancy}
                                            />
                                          </Card>
                                        </Badge.Ribbon>
                                      </Col>
                                    ))}
                                  </Row>
                                ),
                              },
                            ]}
                          />,
                        ]
                      : null
                  }
                >
                  <List.Item style={{ padding: "0px" }} key={room.room_name}>
                    <Row gutter={[16, 16]} justify="space-between">
                      <Col xs={24} sm={20} md={16} lg={12} xl={9}>
                        <div
                          style={{
                            maxWidth: "650px",
                            height: "300px",
                          }}
                        >
                          <Badge.Ribbon
                            className="primary-color"
                            text={room.room_category.title.toUpperCase()}
                          >
                            <Carousel autoplay>
                              {room.room_images.map((image, index) => (
                                <div key={index}>
                                  <img
                                    alt={room.room_name}
                                    src={IMAGE_BASE_URL + image.image.filePath}
                                    style={{
                                      width: "100%",
                                      height: "300px",
                                      objectFit: "cover",
                                      borderRadius: "10px",
                                    }}
                                  />
                                </div>
                              ))}
                            </Carousel>
                          </Badge.Ribbon>
                        </div>
                      </Col>
                      <Col xs={24} sm={20} md={16} lg={12} xl={14}>
                        <List.Item.Meta
                          title={
                            <strong style={{ fontSize: "20px" }}>
                              {room.room_name}
                            </strong>
                          }
                          description={
                            <div>
                              <ServiceList
                                room_type={room.room_type}
                                occupancy={room.occupancy}
                              />
                              <br />
                              <p style={{ fontSize: "16px" }}>
                                {room.seo_description}
                              </p>
                            </div>
                          }
                        />
                      </Col>
                      <Col span={20} className="mobile-hide">
                        <div>
                          <strong style={{ fontSize: "20px" }}>
                            Amenities
                          </strong>
                          <Row gutter={[16, 8]}>
                            {room.room_facility.map((e, index) => {
                              return (
                                <Col key={index} xs={24} sm={12} md={8}>
                                  <img
                                    alt={e.facility.title}
                                    src={
                                      IMAGE_BASE_URL +
                                      e.facility.web_image?.filePath
                                    }
                                    style={{
                                      height: 30,
                                      margin: "20px",
                                    }}
                                  />

                                  <strong>{e.facility.title}</strong>
                                </Col>
                              );
                            })}
                          </Row>
                        </div>
                      </Col>
                      <Col span={4} className="mobile-hide">
                        <div>
                          <Row gutter={[16, 16]} style={{ textAlign: "right" }}>
                            <Col span={24}>
                              <h2>
                                <strong>INR {room.room_amt}</strong>
                              </h2>
                            </Col>
                            <Col span={24}>
                              <Space>
                                <Button
                                  style={{ borderRadius: RADIUS }}
                                  className="primary-color"
                                  loading={loading}
                                  onClick={() => {
                                    setRoomDetail(room);
                                    setRoomPopup(true);
                                  }}
                                >
                                  View
                                </Button>
                                {!isInCart(room) ? (
                                  <Button
                                    style={{ borderRadius: RADIUS }}
                                    className="primary-color"
                                    loading={loading}
                                    disabled={isInCart(room)}
                                    onClick={() => addToCart(room)}
                                    icon={<PlusOutlined />}
                                  >
                                    Add
                                  </Button>
                                ) : (
                                  <Button
                                    style={{ borderRadius: RADIUS }}
                                    className="primary-color"
                                    loading={loading}
                                    disabled={!isInCart(room)}
                                    onClick={() => removeFromCart(room.id)}
                                    icon={<DeleteOutlined />}
                                  >
                                    Remove
                                  </Button>
                                )}
                              </Space>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                    <Row
                      gutter={[16, 16]}
                      className="web-hide"
                      justify="space-between"
                    >
                      <Col span={12}>
                        <h2>
                          <strong>INR {room.room_amt}</strong>
                        </h2>
                      </Col>
                      <Col span={12} style={{ textAlign: "end" }}>
                        <Button
                          style={{ borderRadius: RADIUS }}
                          className="primary-color"
                          loading={loading}
                          onClick={() => {
                            setRoomDetail(room);
                            setRoomPopup(true);
                          }}
                        >
                          View
                        </Button>
                        {!isInCart(room) ? (
                          <Button
                            style={{ borderRadius: RADIUS }}
                            className="primary-color"
                            loading={loading}
                            disabled={isInCart(room)}
                            onClick={() => addToCart(room)}
                            icon={<PlusOutlined />}
                          >
                            Add
                          </Button>
                        ) : (
                          <Button
                            style={{ borderRadius: RADIUS }}
                            className="primary-color"
                            loading={loading}
                            disabled={!isInCart(room)}
                            onClick={() => removeFromCart(room.id)}
                            icon={<DeleteOutlined />}
                          >
                            Remove
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </List.Item>
                </Card>
              )}
            />
          ) : (
            <Card
              title="Enter Your Details"
              extra={
                <Button
                  className="primary-color"
                  loading={loading}
                  style={{
                    marginTop: "5px",
                    marginBottom: "5px",
                  }}
                  onClick={() => setIsCheckout(false)}
                  ghost
                >
                  <RollbackOutlined />
                </Button>
              }
            >
              <Form
                layout="vertical"
                onFinish={handleFormSubmit}
                initialValues={
                  LS_SERVICE.get("id") &&
                  LS_SERVICE.get("user_type") === "customer"
                    ? {
                        email: LS_SERVICE.get("email"),
                        phone: LS_SERVICE.get("phone"),
                        name: LS_SERVICE.get("name"),
                      }
                    : null
                }
              >
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <Form.Item name="name" label="Full Name" required>
                      <AntInput
                        value={userDetails.name}
                        onChange={(e) =>
                          setUserDetails({
                            ...userDetails,
                            name: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Email"
                      required
                      name="email"
                      rules={[
                        {
                          required: true,
                          message: "Please input your email!",
                        },
                        {
                          type: "email",
                          message: "Please enter a valid email address!",
                        },
                      ]}
                    >
                      <AntInput
                        value={userDetails.email}
                        onChange={(e) =>
                          setUserDetails({
                            ...userDetails,
                            email: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Phone"
                      required
                      name="phone"
                      rules={[
                        {
                          required: true,
                          message: "Please input your phone number!",
                        },
                        {
                          pattern: /^[0-9]{10}$/,
                          message:
                            "Please enter a valid 10-digit phone number!",
                        },
                      ]}
                    >
                      <AntInput
                        value={userDetails.phone}
                        onChange={(e) =>
                          setUserDetails({
                            ...userDetails,
                            phone: e.target.value,
                          })
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Button
                  className="primary-color"
                  loading={loading}
                  htmlType="submit"
                  block
                >
                  Submit Booking
                </Button>
              </Form>
            </Card>
          )}
        </Col>

        {/* Right Column (Reservation Summary) */}
        <Col xs={24} sm={24} md={8} lg={6} xl={6}>
          <Card className="sidebar" style={{ borderRadius: RADIUS }}>
            <h3>
              <strong style={{ fontSize: "20px" }}>Reservation Summary</strong>
            </h3>

            {/* <div
              style={{
                borderTop: "1px dashed #ccc",
                margin: "15px 0",
                width: "100%",
              }}
            /> */}
            {/* <div>
              <RangePicker
                style={{ width: "100%" }}
                value={dates}
                onChange={(value) => {
                  setDates(value);
                  totalDays(value);
                  getData(adults, children, value);
                }}
                disabledDate={(current) =>
                  current && current < moment().endOf("day")
                }
              />
            </div> */}

            {/* Adults and Children Select Inputs */}
            {/* <Row gutter={16} style={{ marginTop: "16px" }}>
              <Col span={12}>
                <Select
                  value={adults}
                  onChange={(value) => {
                    setAdults(value);
                    getData(value, children);
                  }}
                  style={{ width: "100%" }}
                  options={[
                    { value: 1, label: "1 Adult" },
                    { value: 2, label: "2 Adults" },
                    { value: 3, label: "3 Adults" },
                    { value: 4, label: "4 Adults" },
                    { value: 5, label: "5 Adults" },
                  ]}
                />
              </Col>
              <Col span={12}>
                <Select
                  value={children}
                  onChange={(value) => {
                    setChildren(value);
                    getData(adults, value);
                  }}
                  style={{ width: "100%" }}
                  options={[
                    { value: 0, label: "0 Children" },
                    { value: 1, label: "1 Child" },
                    { value: 2, label: "2 Children" },
                    { value: 3, label: "3 Children" },
                    { value: 4, label: "4 Children" },
                  ]}
                />
              </Col>
            </Row> */}

            <div
              style={{
                borderTop: "1px dashed #ccc",
                margin: "15px 0",
                width: "100%",
              }}
            />

            {cart.map((item) => (
              <Card
                key={item.id}
                size="small"
                className="cart-item"
                // cover={
                //   <img
                //     alt={item.room_name}
                //     src={IMAGE_BASE_URL + item.room_images[0].image.filePath}
                //   />
                // }
                actions={[
                  <EyeOutlined
                    disabled={isCheckout}
                    style={{ color: "grey" }}
                    onClick={() => {
                      setRoomDetail(item);
                      setRoomPopup(true);
                    }}
                  />,
                  <DeleteOutlined
                    disabled={isCheckout}
                    style={{ color: !isCheckout ? "red" : "grey" }}
                    onClick={() =>
                      !isCheckout ? removeFromCart(item.id) : null
                    }
                  />,
                ]}
              >
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <h3>
                      <strong>{item.room_name}</strong>
                    </h3>
                  </Col>
                  <Col span={12}>
                    <p style={{ textAlign: "end" }}>INR {item.room_amt}</p>
                  </Col>
                </Row>
                <ServiceList
                  room_type={item.room_type}
                  occupancy={item.occupancy}
                />
              </Card>
            ))}
            <div
              style={{
                border: "1px dashed #ccc",
                borderRadius: "10px",
                padding: "10px",
                marginBottom: "20px",
                marginTop: "20px",
              }}
            >
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <h4>
                    <strong style={{ fontSize: "16px" }}>Total Day's</strong>
                  </h4>
                </Col>
                <Col span={12}>
                  <h4 style={{ textAlign: "end" }}>
                    <strong style={{ fontSize: "16px" }}>{days}</strong>
                  </h4>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <h3>
                    <strong style={{ fontSize: "16px" }}>Sub Total</strong>
                  </h3>
                </Col>
                <Col span={12}>
                  <h3 style={{ textAlign: "end" }}>
                    <strong style={{ fontSize: "16px" }}>
                      INR {gstBillSummery.summary.totalBase}
                    </strong>
                  </h3>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <h3>
                    <strong style={{ fontSize: "16px" }}>Tax</strong>
                  </h3>
                </Col>
                <Col span={12}>
                  <h3 style={{ textAlign: "end" }}>
                    <strong style={{ fontSize: "16px" }}>
                      INR {gstBillSummery.summary.totalGst}
                    </strong>
                  </h3>
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <h3>
                    <strong style={{ fontSize: "20px" }}>Grand Total</strong>
                  </h3>
                </Col>
                <Col span={12}>
                  <h3 style={{ textAlign: "end" }}>
                    <strong style={{ fontSize: "20px" }}>
                      INR {gstBillSummery.summary.grandTotal}
                    </strong>
                  </h3>
                </Col>
              </Row>
            </div>
            {setting &&
            setting.partial_payment_percentage !== 0 &&
            setting.partial_payment_percentage !== null ? (
              <div
                style={{
                  border: "1px dashed #ccc",
                  borderRadius: "10px",
                  padding: "10px",
                  marginBottom: "20px",
                  marginTop: "20px",
                }}
              >
                <Radio.Group
                  value={paymentMode}
                  onChange={(e) => setPaymentMode(e.target.value)}
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                    display: "unset",
                  }}
                >
                  <Row gutter={[16, 16]}>
                    <Col span={16}>
                      <Radio value="full">
                        <h3>
                          <strong style={{ fontSize: "16px" }}>
                            I prefer to pay 100% now
                          </strong>
                        </h3>
                      </Radio>
                    </Col>
                    <Col span={8}>
                      <h3 style={{ textAlign: "end" }}>
                        <strong style={{ fontSize: "16px" }}>
                          (INR {gstBillSummery.summary.grandTotal})
                        </strong>
                      </h3>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} justify={"space-between"}>
                    <div
                      style={{
                        borderTop: "1px dashed #ccc",
                        margin: "15px 0",
                        width: "45%",
                      }}
                    />{" "}
                    <h3 style={{ textAlign: "end" }}>
                      <strong style={{ fontSize: "14px" }}>OR</strong>
                    </h3>
                    <div
                      style={{
                        borderTop: "1px dashed #ccc",
                        margin: "15px 0",
                        width: "45%",
                      }}
                    />
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={16}>
                      <Radio value="partial">
                        <h3>
                          <strong style={{ fontSize: "16px" }}>
                            I prefer to pay{" "}
                            {setting?.partial_payment_percentage ?? 0}% now
                          </strong>
                        </h3>
                      </Radio>
                    </Col>
                    <Col span={8}>
                      <h3 style={{ textAlign: "end" }}>
                        <strong style={{ fontSize: "16px" }}>
                          (INR{" "}
                          {Math.round(
                            (gstBillSummery.summary.grandTotal *
                              setting?.partial_payment_percentage ?? 0) / 100
                          )}
                          )
                        </strong>
                      </h3>
                    </Col>
                  </Row>
                </Radio.Group>
              </div>
            ) : (
              <></>
            )}
            {!isCheckout ? (
              <Button
                style={{ borderRadius: RADIUS }}
                className="primary-color"
                loading={loading}
                size="large"
                block
                onClick={handleCheckout}
              >
                Book Now
              </Button>
            ) : null}

            <div
              style={{
                borderTop: "1px dashed #ccc",
                margin: "15px 0",
                width: "100%",
              }}
            />

            <Button
              style={{ borderRadius: RADIUS }}
              className="red-color"
              loading={loading}
              size="large"
              block
              onClick={() => (window.location.href = BACKEND_BASE_URL)}
            >
              Cancel
            </Button>
            <h3
              style={{
                fontSize: "14px",
                textAlign: "center",
                color: "grey",
                marginTop: "10px",
              }}
            >
              <strong>100% Secure Online Payment</strong>
            </h3>
          </Card>
        </Col>
      </Row>

      <BookingPaymentSuccessModal
        visible={isPaySuccess}
        closeSuccessModel={closeSuccessModel}
      />

      <RoomPopup
        visible={roomPopup}
        room={roomDetail}
        onClose={() => {
          setRoomDetail(null);
          setRoomPopup(false);
        }}
      />
    </>
  );
};

export default CommonBookingForm;
